import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService, ScreenType } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrl: './marketplace-wallet-page.component.scss',
})
export class MarketplaceWalletPageComponent {
  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService,
    private location: Location
  ) {}
  id: string;
  screenSize = ScreenType;

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '0';
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }

  goBack() {
    this.location.back();
  }
}
